module.exports = __webpack_public_path__ + "img/list_icon.262850f8.svg";